export const TIKTOK_INVITE_TARGET_PATH = "/library/vraag/demo/a";
export const PARENT_AUDIENCE_SESSION_KEY = "wiswiz_audience_ouder";

export type SearchParamReader = {
  get(name: string): string | null;
};

export function isParentAudienceSearchParams(
  searchParams: SearchParamReader | null | undefined
): boolean {
  return (
    searchParams?.get("audience") === "ouder" ||
    searchParams?.get("recipient") === "ouder"
  );
}

export function buildTikTokInviteRedirectPath(
  sourceSearchParams: URLSearchParams
): string {
  const isParentRecipient = isParentAudienceSearchParams(sourceSearchParams);
  const targetSearchParams = new URLSearchParams();

  targetSearchParams.set("tour", "tiktok");

  if (isParentRecipient) {
    targetSearchParams.set("recipient", "ouder");
    targetSearchParams.set("audience", "ouder");
  }

  sourceSearchParams.forEach((value, key) => {
    if (key === "tour") return;
    if (isParentRecipient && (key === "recipient" || key === "audience")) {
      return;
    }
    targetSearchParams.append(key, value);
  });

  const query = targetSearchParams.toString();
  return `${TIKTOK_INVITE_TARGET_PATH}${query ? `?${query}` : ""}`;
}

export function searchParamsRecordToURLSearchParams(
  searchParams: Record<string, string | string[] | undefined>
): URLSearchParams {
  const result = new URLSearchParams();

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value === undefined) return;
    if (Array.isArray(value)) {
      value.forEach((singleValue) => result.append(key, singleValue));
      return;
    }
    result.append(key, value);
  });

  return result;
}
